export default {
  close_account: ({ close_account }) => close_account,
}